import { Customer } from './customer';
import { LanguageEnum, Role } from '../enums';
import { Partner } from './partner';

export interface UserAccount {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  customer?: Customer;
  partner?: Partner;
  role: Role;
  isAdmin: boolean;
  isUser: boolean;
  isPartner: boolean;
  language: LanguageEnum;
}

export namespace UserAccount {
  export function mapFromApiValue({ role, language, ...restOfUser }: any): UserAccount {
    const _role = Role.mapFromApiValue(role);
    return {
      ...restOfUser,
      role: _role,
      isAdmin: _role === Role.GlobalAdmin,
      isUser: _role === Role.User,
      isPartner: _role === Role.Partner,
      language: LanguageEnum.mapFromApiValue(language),
    };
  }
}
